module.exports = __webpack_public_path__ + "img/undefined.2bd5be5a.svg";